import { render, staticRenderFns } from "./DialogAddEditNotes.vue?vue&type=template&id=4126f2f4"
import script from "./DialogAddEditNotes.js?vue&type=script&lang=js&external"
export * from "./DialogAddEditNotes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports